<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ clientTypeId ? 'Update Client Types' : 'Create Client Types' }} </h3>
        </div>
        <div class="card-body">
          <customers-client-types-form
            [clientType]="clientType"
            (onSavedData)="onItemProductFormSavedData($event)"
          />
        </div>
      </div>
    </div>
    
  </div>
  